import { lazy } from 'react';
import { AppRouteType } from 'shared/types';
import { HiddenFeatures } from '../../shared/services/env.service';
import { envService } from '../../shared/services';
import { Permissions } from '../../shared/services/permission.service';

const Login = lazy(() => import('../../features/auth/pages/Login/Login'));
const Product = lazy(() => import('../../features/products/pages/ProductList/ProductList'));
const Region = lazy(() => import('../../features/regions/pages/RegionList/RegionList'));
const DocumentCreate = lazy(() => import('../../features/documents/pages/DocumentCreate'));
const DocumentDetail = lazy(() => import('../../features/documents/pages/DocumentDetail'));
const ProductDetail = lazy(() => import('../../features/products/pages/ProductDetail/ProductDetail'));
const RegionDetail = lazy(() => import('../../features/regions/pages/RegionDetail/RegionDetail'));
const RegionProduct = lazy(() => import('../../features/regions/pages/RegionProduct/RegionProduct'));
const ServiceProvider = lazy(
  () => import('../../features/service-providers/pages/ServiceProviderList/ServiceProviderList'),
);
const Logistique = lazy(() => import('../../features/logistics/pages/Logistique/Logistique'));
const ServiceProviderDetail = lazy(() => import('../../features/service-providers/pages/ServiceProviderDetail'));
const SearchPriceLogistique = lazy(() => import('../../pages/SearchPriceLogistique'));
const SearchPriceCommercial = lazy(() => import('../../pages/SearchPriceCommercial'));
const ProviderInvoice = lazy(() => import('../../pages/ProviderInvoice'));
const ProviderInvoiceCreateEdit = lazy(() => import('../../pages/ProviderInvoiceCreate'));
const Renouvellement = lazy(() => import('../../features/renouvellement/pages/Renouvellement'));

export const routes: AppRouteType[] = [
  { name: 'Login', auth: false, path: '/login', component: Login },
  { name: 'Product', auth: true, path: '/products', component: Product, permissions: [Permissions.PRODUITS] },
  {
    name: 'ProductDetail',
    auth: true,
    path: '/products/:productTypeId',
    component: ProductDetail,
    permissions: [Permissions.PRODUITS],
  },
  { name: 'Region', auth: true, path: '/regions', component: Region, permissions: [Permissions.REGIONS] },
  {
    name: 'RegionDetail',
    auth: true,
    path: '/regions/:regionId',
    component: RegionDetail,
    permissions: [Permissions.REGIONS],
  },
  {
    name: 'RegionProduct',
    auth: true,
    path: '/regions/:regionId/products',
    component: RegionProduct,
    permissions: [Permissions.REGIONS],
  },
  {
    name: 'Nouveslles Commandes',
    auth: true,
    path: '/logistique/nouvelles-commandes',
    component: Logistique,
    permissions: [Permissions.LOGISTIQUE],
  },
  {
    name: 'Benneur',
    auth: true,
    path: '/prestataires/benneur',
    component: ServiceProvider,
    permissions: [Permissions.PRESTATAIRE_BENNEUR],
  },
  {
    name: 'Benneur Detail',
    auth: true,
    path: '/prestataires/benneur/:serviceProviderId',
    component: ServiceProviderDetail,
    permissions: [Permissions.PRESTATAIRE_BENNEUR],
  },
  {
    name: 'Camionneur',
    auth: true,
    path: '/prestataires/camionneur',
    component: ServiceProvider,
    permissions: [Permissions.PRESTATAIRE_CAMION],
  },
  {
    name: 'Camionneur Detail',
    auth: true,
    path: '/prestataires/camionneur/:serviceProviderId',
    component: ServiceProviderDetail,
    permissions: [Permissions.PRESTATAIRE_CAMION],
  },
  {
    name: 'Decheterie',
    auth: true,
    path: '/prestataires/decheterie',
    component: ServiceProvider,
    permissions: [Permissions.PRESTATAIRE_DECHETERIE],
  },
  {
    name: 'Decheterie Detail',
    auth: true,
    path: '/prestataires/decheterie/:serviceProviderId',
    component: ServiceProviderDetail,
    permissions: [Permissions.PRESTATAIRE_DECHETERIE],
  },
  {
    name: 'Search',
    auth: true,
    path: '/search/logistique',
    component: SearchPriceLogistique,
    permissions: [Permissions.PRESTATAIRE_BENNEUR],
  },
  {
    name: 'Search',
    auth: true,
    path: '/search/commercial',
    component: SearchPriceCommercial,
    permissions: [Permissions.DEVIS],
  },
  {
    name: 'SupplierInvoice',
    auth: true,
    path: '/logistique/factures-fournisseurs',
    component: ProviderInvoice,
    permissions: [Permissions.PRESTATAIRE_BENNEUR],
  },
  {
    name: 'SupplierInvoice',
    auth: true,
    path: '/logistique/factures-fournisseurs/:invoiceNumber',
    component: ProviderInvoiceCreateEdit,
    permissions: [Permissions.PRESTATAIRE_BENNEUR],
  },
  {
    name: 'SupplierInvoice',
    auth: true,
    path: '/logistique/factures-fournisseurs/enregistrer-facture',
    component: ProviderInvoiceCreateEdit,
    permissions: [Permissions.PRESTATAIRE_BENNEUR],
  },
  {
    name: 'RenouvellementList',
    auth: true,
    path: '/renouvellement-de-benne',
    component: Renouvellement,
    permissions: [Permissions.RENOUVELLEMENT],
  },
  ...(!envService.isFeatureHidden(HiddenFeatures.DEVIS)
    ? [
        {
          name: 'Quotation',
          auth: true,
          path: '/quotation',
          component: DocumentCreate,
          permissions: [Permissions.DEVIS],
        },
        { name: 'Order', auth: true, path: '/order', component: DocumentCreate, permissions: [Permissions.DEVIS] },
        {
          name: 'QuotationDetail',
          auth: true,
          path: '/quotation/:documentId',
          component: DocumentDetail,
          permissions: [Permissions.DEVIS],
        },
        {
          name: 'OrderDetail',
          auth: true,
          path: '/order/:documentId',
          component: DocumentDetail,
          permissions: [Permissions.DEVIS],
        },
      ]
    : []),
];
